export const helpdeskBaseUrl = 'https://helpdesk.kaseya.com/hc/en-gb';

export const helpdeskContactUrl = `${helpdeskBaseUrl}#/phone`;
